/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StemParent
 */
export interface StemParent {
    /**
     * 
     * @type {string}
     * @memberof StemParent
     */
    category: string;
    /**
     * 
     * @type {number}
     * @memberof StemParent
     */
    parentTrackId: number;
}

/**
 * Check if a given object implements the StemParent interface.
 */
export function instanceOfStemParent(value: object): value is StemParent {
    let isInstance = true;
    isInstance = isInstance && "category" in value && value["category"] !== undefined;
    isInstance = isInstance && "parentTrackId" in value && value["parentTrackId"] !== undefined;

    return isInstance;
}

export function StemParentFromJSON(json: any): StemParent {
    return StemParentFromJSONTyped(json, false);
}

export function StemParentFromJSONTyped(json: any, ignoreDiscriminator: boolean): StemParent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': json['category'],
        'parentTrackId': json['parent_track_id'],
    };
}

export function StemParentToJSON(value?: StemParent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': value.category,
        'parent_track_id': value.parentTrackId,
    };
}

